import './VideoSection.css';

const videos = [
  'https://www.youtube.com/embed/RuynpV90wzY', 'https://www.youtube.com/embed/UqdgAJbFvN8',
  'https://www.youtube.com/embed/ZTZVuMLsCLw', 'https://www.youtube.com/embed/u6dRbyvILns',
  'https://www.youtube.com/embed/F35zjF-gwm4', 'https://www.youtube.com/embed/VnuX72oiVVQ',
  'https://www.youtube.com/embed/iBlZDnME-nY', 'https://www.youtube.com/embed/7nLT7rSFeUE',
  'https://www.youtube.com/embed/FzTrklerlbE',
];

const VideoSection = () => (
  <section className="home-videos" aria-labelledby="videos-title">
    <div className="container home-videos__container">
      <div className="home-videos__heading">
        <span>Learn on your time</span>
        <h2 id="videos-title">Popular market insights</h2>
        <p>Short, practical videos to sharpen your market perspective.</p>
      </div>
      <div className="home-videos__rail" aria-label="Popular videos">
        {videos.map((video, index) => (
          <article className="home-videos__item" key={video}>
            <iframe src={video} title={`Thakur Capital market insight ${index + 1}`} loading="lazy" allowFullScreen />
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default VideoSection;
